import { UUID } from '@cmg/common';
import { Alert, DomainObject } from '@cmg/design-system';
import { FC, Fragment } from 'react';

import {
  OfferingStage as OfferingStageEnum,
  OfferingStatus as OfferingStatusEnum,
  OfferingType,
  Sector,
  SecurityType,
} from '../../../../graphql';
import { Offering_OfferingHeader_OfferingTermsPartsFragment } from '../../graphql';
import { OfferingDomainHighlights } from './OfferingDomainHighlights';
import { OfferingNavbar } from './OfferingNavbar';

export type Props = {
  offeringId?: UUID;
  status?: OfferingStatusEnum;
  stage: OfferingStageEnum;
  issuerName?: string;
  type?: OfferingType;
  isAuthor: boolean;
  isInternal: boolean;
  sector?: Sector | null;
  isSharedDraft?: boolean;
  isDiscarded: boolean;
  sizeInShares?: number | null;
  securityType?: SecurityType;
  terms?: Offering_OfferingHeader_OfferingTermsPartsFragment;
  pricingCountryCode?: string | null;
  pricingCurrencyCode?: string;
  isWallCrossEnabled?: boolean;
  offeringCountryCode?: string;
};

/**
 * OfferingHeader displays a summary of the offering and a quick access dropdown
 * to my offerings
 */
export const OfferingDomainObject: FC<Props> = ({
  offeringId,
  status,
  stage,
  issuerName,
  type,
  isAuthor,
  isInternal,
  sector,
  isSharedDraft = false,
  isDiscarded,
  sizeInShares,
  securityType,
  terms,
  pricingCountryCode,
  pricingCurrencyCode,
  isWallCrossEnabled,
  offeringCountryCode,
}) => {
  return (
    <Fragment>
      {issuerName && (
        <DomainObject
          domainHighlights={
            <OfferingDomainHighlights
              offeringId={offeringId}
              issuerName={issuerName}
              type={type}
              status={status}
              sector={sector}
              sizeInShares={sizeInShares}
              securityType={securityType}
              terms={terms}
              pricingCountryCode={pricingCountryCode}
              pricingCurrencyCode={pricingCurrencyCode}
            />
          }
          domainNav={
            <OfferingNavbar
              isAuthor={isAuthor}
              isSharedDraft={isSharedDraft}
              isDiscarded={isDiscarded}
              isInternal={isInternal}
              offeringId={offeringId}
              offeringStage={stage}
              offeringType={type}
              offeringStatus={status}
              isWallCrossEnabled={isWallCrossEnabled}
              offeringCountryCode={offeringCountryCode}
            />
          }
        />
      )}
      {isDiscarded && <Alert color="error">This offering has been discarded</Alert>}
    </Fragment>
  );
};
